import { ApiClientReturnType, TableDataType } from '~/types';
import api from '../http-common';
import { CoolFarmOptionsType } from '~/pages/Farmer/CoolFarm/AnswerCoolFarm/types';

const getCoolFarmFootprints = (data?): ApiClientReturnType<CoolFarmDataType> =>
  api.post('/cool-farm-tool/footprints/index', data)

const getCoolFarmCountActive = () =>
  api.post('/cool-farm-tool/footprints/count-active')

const getCoolFarmOptions = (data?) =>
  api.post('/cool-farm-tool/footprints/get-index-data', data)

const getCoolFarmCount = (data?) =>
  api.post('/cool-farm-tool/footprints/count', data)

const getCoolFarmDairyAnsOptions = (id: string): ApiClientReturnType<CoolFarmOptionsType> =>
  api.post(`/cool-farm-tool/footprints/${id}/answer/get-options-data`)

const saveCoolFarmAnswers = (id: string, data) =>
  api.post(`/cool-farm-tool/footprints/${id}/answer/save`, data)

const editCoolFarmAnswers = (id: string) =>
  api.post(`/cool-farm-tool/footprints/${id}/answer/edit`)

const storeCoolFarmAnswers = (id: string, data) =>
  api.post(`/cool-farm-tool/footprints/${id}/answer/store`, data)

const checkCoolFarmAnswers = (id: string, data) =>
  api.post(`/cool-farm-tool/footprints/${id}/answer/check`, data)

const getResultsCoolFarm = (id: string, data?) =>
  api.post(`/cool-farm-tool/footprints/${id}/answer/get-results`, data)

export const CoolFarmService = {
  getCoolFarmFootprints,
  getCoolFarmCountActive,
  getCoolFarmOptions,
  getCoolFarmCount,
  getCoolFarmDairyAnsOptions,
  saveCoolFarmAnswers,
  storeCoolFarmAnswers,
  editCoolFarmAnswers,
  checkCoolFarmAnswers,
  getResultsCoolFarm
}

export interface CoolFarmDairyResultsType {
  totalEmission: string;
  emissionPerFpcm: string;

  // Total emissions by gas type
  totalCo2Emission: string;
  totalCo2EmissionInCo2e: string;
  totalN2oEmission: string;
  totalN2oEmissionInCo2e: string;
  totalCh4Emission: string;
  totalCh4EmissionInCo2e: string;

  // Energy emissions
  energyCo2Emission: string;
  energyN2oEmission: string;
  energyCh4Emission: string;
  energyTotalEmission: string;
  energyEmissionPerFpcm: string;

  // Enteric emissions
  entericCo2Emission: string;
  entericN2oEmission: string;
  entericCh4Emission: string;
  entericTotalEmission: string;
  entericEmissionPerFpcm: string;

  // Feed emissions
  feedCo2Emission: string;
  feedN2oEmission: string;
  feedCh4Emission: string;
  feedTotalEmission: string;
  feedEmissionPerFpcm: string;

  // Fertilizer emissions
  fertilizerCo2Emission: string;
  fertilizerN2oEmission: string;
  fertilizerCh4Emission: string;
  fertilizerTotalEmission: string;
  fertilizerEmissionPerFpcm: string;

  // Grazing emissions
  grazingCo2Emission: string;
  grazingN2oEmission: string;
  grazingCh4Emission: string;
  grazingTotalEmission: string;
  grazingEmissionPerFpcm: string;

  // Manure emissions
  manureCo2Emission: string;
  manureN2oEmission: string;
  manureCh4Emission: string;
  manureTotalEmission: string;
  manureEmissionPerFpcm: string;

  // Transport emissions
  transportCo2Emission: string;
  transportN2oEmission: string;
  transportCh4Emission: string;
  transportTotalEmission: string;
  transportEmissionPerFpcm: string;

  farmerId: string;
}

export type CoolFarmDataType = TableDataType<CoolFarmSlotType>

export interface CoolFarmSlotType {
  id: string;
  uniqueId: string;
  status: number;
  title: string;
  start: string;
  end: string;
  periodFrom: Date;
  periodTo: Date;
  completed: number;
  completedAt: Date;
  hasAnswer: number;
  statusLabel: string;
  crops?: Crop[];
}

export interface Crop {
  id: number;
  name: string;
  farmerId: string;
  cftFootprintId: string;
}
